import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    function onScroll() {
      setShowTop(window.scrollY > 600);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <footer className="mt-16 border-t border-background-200/80 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-base font-bold text-background-50">
                灼
              </span>
              <div className="leading-none">
                <p className="font-heading text-base font-bold text-foreground-950">
                  灼见社
                </p>
                <p className="mt-1 text-[11px] text-foreground-600">
                  独家内幕 · 深度揭秘
                </p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              深挖独家内幕与幕后真相，从知情人士视角还原事件背后的真实逻辑，为对世界好奇的你持续提供有分量的深度内容。
            </p>
            <p className="mt-4 text-sm text-foreground-600">
              商务与线索沟通：{" "}
              <a
                href="mailto:contact@zhuojianshe.example"
                className="text-primary-600 underline-offset-2 hover:text-primary-700 hover:underline"
              >
                contact@zhuojianshe.example
              </a>
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              栏目导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/channel/${c.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              快速前往
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/article/gala-c-seat"
                  className="text-sm text-foreground-600 hover:text-primary-600"
                >
                  本周独家头条
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/#subscribe" className="text-sm text-foreground-600 hover:text-primary-600">
                  订阅内幕邮件
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">
              平台定位
            </h4>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              我们坚持多方信源交叉核验，每一篇深度报道都在追求还原真相的同时守住边界。欢迎提供可靠线索，也欢迎对内容提出异议。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-sm text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 灼见社 Zhuojian. 保留所有权利。</p>
          <p className="text-xs text-foreground-400">
            本站内容均为原创深度报道，观点不代表任何机构立场。
          </p>
        </div>
      </div>

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}
    </footer>
  );
}